import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class AlertBanner extends Vue {
    @Prop(String) readonly variant!: string
    @Prop(String) readonly text!: string
    @Prop({ default: false }) readonly close!: boolean
    @Prop({ default: false }) readonly show!: boolean
}
